/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconChecks = createReactComponent("checks", "IconChecks", [
  ["path", { d: "M7 12l5 5l10 -10", key: "svg-0" }],
  ["path", { d: "M2 12l5 5m5 -5l5 -5", key: "svg-1" }]
]);

export { IconChecks as default };
//# sourceMappingURL=IconChecks.js.map
